import { render } from "./SocialView.vue?vue&type=template&id=f0ecc6dc&scoped=true"
import script from "./SocialView.vue?vue&type=script&lang=js"
export * from "./SocialView.vue?vue&type=script&lang=js"

import "./SocialView.vue?vue&type=style&index=0&id=f0ecc6dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0ecc6dc"]])

export default __exports__